import axios from 'axios'
//#Local Domain
// const URL = "http://192.168.100.41:5000/api/"; 

//#Demo Domain       
//const URL = "https://uat-7.innkeylive.com/api/";

 //const URL = "http://192.168.100.41:5000/api/"

//#Live Domain  
const URL = "https://managerapp.innkeyapp.com/api/";

export const GetPropertyDetails = (ClientID, PropertyID) => {
    const apiUrl = URL + "MVReservationData/GetPropertyDetails/" + ClientID + '/' + PropertyID;
    return axios.get(apiUrl)
};
export const GetReservationData = (ClientID, PropertyID, BookingNo) => {
    const apiUrl = URL + "Reservation/GetReservationData/" + ClientID + '/' + PropertyID + '/' + BookingNo;
    return axios.get(apiUrl)
}
export const GetNationality = (ClientID) => {
    const apiUrl = URL + "MVReservationData/GetNationality/" + ClientID;
    return axios.get(apiUrl)
}
export const GetCountryList = (ClientID) => {
    const apiUrl = URL + "MVReservationData/GetCountryList/" + ClientID;
    return axios.get(apiUrl)
}
export const GetRoomGuestData = (ClientID, PropertyID, BookingNo) => {
    const apiUrl = URL + "MVReservationData/GetRoomGuestData/" + ClientID + '/' + PropertyID + '/' + BookingNo;
    return axios.get(apiUrl)
}
export const GetmobileGuestProfileSub = (ClientID, PropertyID, BookingNo) => {
    const apiUrl = URL + "MVReservationData/GetmobileGuestProfileSub/" + ClientID + '/' + PropertyID + '/' + BookingNo;
    return axios.get(apiUrl)
}
export const GetIdentificationForSelfCheckinapp = (ClientID) => {
    const apiUrl = URL + "MVReservationData/GetIdentificationForSelfCheckinapp/" + ClientID;
    return axios.get(apiUrl)
}
export const GetCityListfromCountry = (ClientID,CountryID) => {
    const apiUrl = URL + "MVReservationData/GetCityListfromCountry/" + ClientID + '/' + CountryID;
    return axios.get(apiUrl)
}
export const InsertGuestDetailSingle = (para) => {
    const apiUrl = URL + "MVReservationData/InsertGuestDetailsSingle";
    return axios.post(apiUrl,para);
} 
export const InsertDigitalSigniture = (para) => {
    const apiUrl = URL + "MVReservationData/InsertDigitalSignature";
    return axios.post(apiUrl,para);
} 
export const GetEncodedString = (str) => {
    const apiUrl = URL + "Reservation/GetEncodedString/" + str;
    return axios.get(apiUrl)
}
export const GetDecodedString = (str) => {
    const apiUrl = URL + "Reservation/GetDecodedString/" + str;
    return axios.get(apiUrl)
}
export const ValidateMediaFunction = (para) => {
    const apiUrl = URL + "MVReservationData/manage-media-validator-selfchekin";
    return axios.post(apiUrl,para);
} 